(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3349],{

/***/ 92553:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/revoke",
      function () {
        return __webpack_require__(85019);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 46230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O_": function() { return /* reexport safe */ _useIsClient__WEBPACK_IMPORTED_MODULE_2__.O; },
/* harmony export */   "f5": function() { return /* reexport safe */ _useEventLogs__WEBPACK_IMPORTED_MODULE_5__.f; }
/* harmony export */ });
/* harmony import */ var _useDebounce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97486);
/* harmony import */ var _useFPTRegistry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95249);
/* harmony import */ var _useIsClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17237);
/* harmony import */ var _useNFTMetadata__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56647);
/* harmony import */ var _useWalletNFTs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28372);
/* harmony import */ var _useEventLogs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27462);








/***/ }),

/***/ 85019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77081);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35610);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(907);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47741);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_wrap_balancer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41782);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(38793);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44868);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46230);
/* harmony import */ var _utils_formatAddress__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(61161);









const Activity = ()=>{
    const isClient = (0,_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useIsClient */ .O_)();
    const { isConnected  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_6__/* .useAccount */ .mA)();
    const { data: erc721Events , isLoading  } = (0,_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useEventLogs */ .f5)();
    const [selectedRevoke, setselectedRevoke] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
    const [hideZeroBalance, setHideZeroBalance] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true);
    if (!isConnected && isClient) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .ConnectWallet */ .RZ, {});
    }
    var ref;
    const filteredERC721Events = erc721Events === null || erc721Events === void 0 ? void 0 : erc721Events.filter((z)=>z !== undefined).filter((z)=>{
        return (z === null || z === void 0 ? void 0 : z.allowances.length) !== 0;
    }).filter((z)=>{
        return !hideZeroBalance || ((ref = z === null || z === void 0 ? void 0 : z.balance) !== null && ref !== void 0 ? ref : 0) > 0;
    }).flatMap((event)=>{
        return event === null || event === void 0 ? void 0 : event.allowances.map((allowance)=>({
                ...event,
                allowance: allowance
            }));
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .RevokeDialogue */ .rx, {
                selectedRevoke: selectedRevoke,
                onClose: ()=>setselectedRevoke(undefined)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
                w: "full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .kC, {
                        textAlign: "center",
                        flexDir: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        my: "12",
                        mx: "auto",
                        maxW: "xl",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Heading */ .X6, {
                                mt: "8",
                                zIndex: "1",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_wrap_balancer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    children: "Revoke Approvals"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .xv, {
                                mt: "3",
                                zIndex: "1",
                                color: "slate.600",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_wrap_balancer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    children: "FoolProof Token (FPT) offers unparalleled security and control over digital assets by creating a 1:1 linked token to prove ownership without risking ownership."
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Container */ .W2, {
                        my: {
                            base: 8,
                            md: 12
                        },
                        p: {
                            base: 4,
                            md: 12
                        },
                        maxW: "4xl",
                        rounded: "md",
                        w: "full",
                        marginX: "auto",
                        borderWidth: {
                            base: 0,
                            md: 1
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
                                title: "Revoke"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .kC, {
                                mb: "10",
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .kC, {
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .xv, {
                                                fontSize: "xl",
                                                fontWeight: "bold",
                                                children: "Revoke"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Checkbox */ .XZ, {
                                                isChecked: hideZeroBalance,
                                                onChange: (e)=>setHideZeroBalance(e.target.checked),
                                                children: "Hide zero balance"
                                            })
                                        ]
                                    }),
                                    isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Spinner */ .$, {
                                        mx: "auto",
                                        my: "10"
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Table */ .iA, {
                                        variant: "unstyled",
                                        colorScheme: "brand",
                                        mt: "10",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Thead */ .hr, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__.Tr, {
                                                    borderBottomWidth: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__.Th, {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .xv, {
                                                                children: "Token"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__.Th, {
                                                            w: "50px",
                                                            children: "Type"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__.Th, {
                                                            w: "100px",
                                                            children: "Amount"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__.Th, {
                                                            w: "100px",
                                                            children: "Spender"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__.Th, {
                                                            w: "100px",
                                                            textAlign: "right",
                                                            children: "Action"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Tbody */ .p3, {
                                                children: filteredERC721Events === null || filteredERC721Events === void 0 ? void 0 : filteredERC721Events.map((token)=>{
                                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__.Tr, {
                                                        transition: {
                                                            color: "0.2s"
                                                        },
                                                        sx: {
                                                            transition: "background-color 0.3s ease-in-out"
                                                        },
                                                        _hover: {
                                                            bg: "slate.200",
                                                            _dark: {
                                                                bg: "slate.800"
                                                            }
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__.Td, {
                                                                children: [
                                                                    token === null || token === void 0 ? void 0 : token.contractName,
                                                                    " ",
                                                                    (token === null || token === void 0 ? void 0 : token.tokenType) === "erc20" && "($".concat(token === null || token === void 0 ? void 0 : token.symbol, ")")
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__.Td, {
                                                                w: "100px",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Badge */ .Ct, {
                                                                    size: "sm",
                                                                    mb: "2",
                                                                    colorScheme: (token === null || token === void 0 ? void 0 : token.tokenType) === "erc20" ? "orange" : "teal",
                                                                    children: token === null || token === void 0 ? void 0 : token.tokenType
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__.Td, {
                                                                w: "100px",
                                                                children: token === null || token === void 0 ? void 0 : token.balance.toFixed(2)
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__.Td, {
                                                                w: "150px",
                                                                children: (token === null || token === void 0 ? void 0 : token.allowance.spender) && (0,_utils_formatAddress__WEBPACK_IMPORTED_MODULE_11__/* .formatAddress */ .T)(token === null || token === void 0 ? void 0 : token.allowance.spender)
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__.Td, {
                                                                w: "100px",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Button */ .zx, {
                                                                    onClick: ()=>{
                                                                        return setselectedRevoke({
                                                                            spenderAddress: token === null || token === void 0 ? void 0 : token.allowance.spender,
                                                                            contractAddress: token === null || token === void 0 ? void 0 : token.contractAddress
                                                                        });
                                                                    },
                                                                    variant: "outline",
                                                                    size: "sm",
                                                                    children: "Revoke"
                                                                })
                                                            })
                                                        ]
                                                    }, token === null || token === void 0 ? void 0 : token.transactionHash);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Activity);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(92553); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);